import React from 'react';
import { benefits } from '../eiraa_mock';
import { Sparkles, Droplets, Zap, Heart, Moon, Shield } from 'lucide-react';

const iconMap = {
  Sparkles,
  Droplets,
  Zap,
  Heart,
  Moon,
  Shield
};

const EiraaBenefits = () => {
  return (
    <section id="benefits" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider">Health & Wellness</span>
          <h2 className="text-4xl md:text-5xl font-light text-slate-900 mt-3 mb-4">
            The EIRAA Wellness Experience
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover the transformative health benefits of regular sauna sessions in your personal EIRAA wellness sanctuary.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                className="group bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-amber-300"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-amber-600 group-hover:scale-110 transition-all duration-300">
                  <IconComponent className="text-amber-600 group-hover:text-white transition-colors" size={28} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Wellness Highlight */}
        <div className="mt-20 bg-gradient-to-r from-amber-600 to-amber-500 rounded-3xl p-12 text-center text-white max-w-4xl mx-auto shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-light mb-4">Transform Your Wellness Routine</h3>
          <p className="text-lg text-amber-50 mb-8 max-w-2xl mx-auto">
            Join countless satisfied customers who have elevated their health and wellness with EIRAA premium sauna solutions.
          </p>
          <div className="flex flex-wrap justify-center gap-12">
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">20-30min</div>
              <div className="text-amber-100">Optimal Session</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">3-4x</div>
              <div className="text-amber-100">Weekly Use</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">100%</div>
              <div className="text-amber-100">Natural Therapy</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EiraaBenefits;